<template>
  <v-row no-gutters>
    <v-col no-gutters :cols="12">
      <div class="d-flex align-center mb-2" style="color: var(--color-text)">
        <v-icon left color="var(--color-text)" v-if="iconName">{{
          iconName
        }}</v-icon>
        <v-tooltip right v-if="tooltipText">
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="text-subtitle-1 font-weight-light mr-1"
              style="color: var(--color-text)"
            >
              {{ inputLabel }}
            </span>
          </template>
          <span>{{ tooltipText }}</span>
        </v-tooltip>
        <span
          v-else
          class="text-subtitle-1 font-weight-light mr-1"
          style="color: var(--color-text)"
        >
          {{ inputLabel }}
        </span>
      </div>

      <div>
        <slot name="inputComponent" />
      </div>
    </v-col>
  </v-row>
</template>

  <script>
export default {
  name: "TitledInputField",
  props: {
    inputLabel: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      default: null, // Default icon
    },
    tooltipText: {
      type: String,
      default: null,
    },
  },
};
</script>
